/**
 * Un fichier lâché À CÔTÉ d'une zone de dépôt ne doit pas faire quitter la page.
 *
 * Sans ce garde, le navigateur applique son comportement par défaut : il ouvre
 * le fichier dans l'onglet, à la place de l'application. Les zones de dépôt sont
 * petites (une ligne de pièce sur la fiche formateur) ; il suffit de viser un
 * centimètre trop bas pour perdre la page et ce qu'on y avait saisi.
 *
 * Les zones qui acceptent un fichier appellent déjà `preventDefault` : c'est à
 * cela qu'on les reconnaît (`defaultPrevented`), et on ne touche alors à rien.
 * Partout ailleurs, le curseur dit « interdit » et le lâcher est sans effet.
 * Seuls les glissers de FICHIERS sont concernés — un texte glissé dans un champ
 * garde son comportement.
 */
const porteDesFichiers = (event) => Array.from(event.dataTransfer?.types || []).includes('Files')

function surSurvol(event) {
  if (!porteDesFichiers(event) || event.defaultPrevented) return
  event.preventDefault()
  event.dataTransfer.dropEffect = 'none'
}

function surLacher(event) {
  if (!porteDesFichiers(event) || event.defaultPrevented) return
  event.preventDefault()
}

export function installerGardeDepotFichier(cible = window) {
  cible.addEventListener('dragover', surSurvol)
  cible.addEventListener('drop', surLacher)
  return () => {
    cible.removeEventListener('dragover', surSurvol)
    cible.removeEventListener('drop', surLacher)
  }
}
